import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { useReveal } from '../../hooks/useReveal';
import mark from '../../images/evolve-mark.png';
import './LabFooter.scss';

const LINKS = [
    { label: 'Products', to: 'products' },
    { label: 'Lab', to: 'lab' },
    { label: 'Technology', to: 'stack' },
    { label: 'About', to: 'about' },
];

const SOCIAL = [
    { label: 'GitHub', href: 'https://github.com' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com' },
];

const LabFooter = () => {
    const [ref, revealed] = useReveal({ threshold: 0.15 });

    return (
        <footer className="lab-footer" ref={ref}>
            <div className={`lf-inner ${revealed ? 'is-in' : ''}`}>
                <div className="lf-always">
                    <img src={mark} alt="" className="lf-watermark" aria-hidden="true" />
                    <span className="lf-always-line">Always</span>
                    <span className="lf-always-line lf-always-accent">Evolving.</span>
                </div>

                <div className="lf-meta">
                    <nav className="lf-links">
                        <span className="lf-links-title">Explore</span>
                        {LINKS.map(({ label, to }) => (
                            <ScrollLink
                                key={to}
                                to={to}
                                smooth
                                duration={600}
                                offset={-70}
                                className="lf-link"
                            >
                                {label}
                            </ScrollLink>
                        ))}
                    </nav>

                    <nav className="lf-links">
                        <span className="lf-links-title">Elsewhere</span>
                        {SOCIAL.map(({ label, href }) => (
                            <a
                                key={label}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="lf-link"
                            >
                                {label}
                            </a>
                        ))}
                    </nav>

                    <div className="lf-links">
                        <span className="lf-links-title">Base</span>
                        <span className="lf-static">Detroit / USA</span>
                        <span className="lf-static">Est. 2024</span>
                    </div>
                </div>

                <div className="lf-wordmark" aria-hidden="true">
                    <span>EVOLVE</span>
                    <span className="lf-wordmark-labs">LABS</span>
                </div>

                <div className="lf-base">
                    <span>Building products one experiment at a time.</span>
                    <span>© {new Date().getFullYear()} Evolve Labs</span>
                </div>
            </div>
        </footer>
    );
};

export default LabFooter;
